import { render, staticRenderFns } from "./SubscriptionSidebar.vue?vue&type=template&id=2b45301a&"
import script from "./SubscriptionSidebar.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports